import type { IconDef } from '../types';

/** Line-drawn person: a head circle over rounded shoulders. */
export const profileOutlined: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M8.4 8a3.6 3.6 0 1 0 7.2 0a3.6 3.6 0 1 0 -7.2 0',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '1.9',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      d: 'M4.8 20c.9-3.4 3.8-5.2 7.2-5.2s6.3 1.8 7.2 5.2',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '1.9',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
};
